function hasAccess(roles, access) {
    if (access === undefined) {
        return true;
    }
    if (roles.some((role) => access.includes(role?.name))) {
        return true;
    }
    return false;
}
export default hasAccess;